var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"top-brand-icon",attrs:{"src":_vm.imageUrl,"alt":_vm.altText}})}
var staticRenderFns = []

export { render, staticRenderFns }